export default [
  {
    inputs: [],
    name: 'Frozen',
    type: 'error'
  },
  {
    inputs: [],
    name: 'InvalidLength',
    type: 'error'
  },
  {
    inputs: [],
    name: 'OutOfRange',
    type: 'error'
  },
  {
    inputs: [],
    name: 'Unavailable',
    type: 'error'
  },
  {
    inputs: [],
    name: 'ZeroIv',
    type: 'error'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'CDF',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'LN',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: 'x',
        type: 'int256'
      }
    ],
    name: 'cdf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'tAnnualised',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'sqrtTs',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'volatility',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'spot',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'strike',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: 'rate',
        type: 'int256'
      }
    ],
    name: 'd1d2',
    outputs: [
      {
        internalType: 'int256',
        name: 'd1',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: 'd2',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'x',
        type: 'uint256'
      }
    ],
    name: 'exp',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: 'x',
        type: 'int256'
      }
    ],
    name: 'exp',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [],
    name: 'freezeCdf',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'freezeLn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'frozenCdf',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'frozenLn',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'now',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'spot',
            type: 'uint256'
          },
          {
            internalType: 'int256',
            name: 'riskFreeRate',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'initialMarginRiskRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'spotFee',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'optionFee',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'minPremium',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'expiry',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'strike',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'iv',
            type: 'uint256'
          },
          {
            internalType: 'int256',
            name: 'size',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'available',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'equity',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'priceRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'priceRatio2',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'priceRatioUtilization',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'isCall',
            type: 'bool'
          }
        ],
        internalType: 'struct IOptionPricer.GetPremiumParams',
        name: 'params',
        type: 'tuple'
      }
    ],
    name: 'getPremium',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'volatility',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    name: 'getPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'x',
        type: 'uint256'
      }
    ],
    name: 'ln',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256[]',
        name: 'keys',
        type: 'uint256[]'
      },
      {
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]'
      }
    ],
    name: 'setCdf',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256[]',
        name: 'keys',
        type: 'uint256[]'
      },
      {
        internalType: 'int256[]',
        name: 'values',
        type: 'int256[]'
      }
    ],
    name: 'setLn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'x',
        type: 'uint256'
      }
    ],
    name: 'sqrt',
    outputs: [
      {
        internalType: 'uint256',
        name: 'y',
        type: 'uint256'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  }
];
